module.exports = "/_next/static/images/OgImageCDPWeek2023-b8acc6cdb3fcbfc94d82f7a4739d0fd7.png";